ubian = ubian || {};
/**
 * Basket related methods
 * @type Object
 */
ubian.basket = {
  INFO_SHOWN_SESSION_KEY: "ubian.basket.info_shown_and_agreed"
};
/**
 * remove item from basket
 * @param {int} id
 * @returns {undefined}
 */
ubian.basket.removeItem = function(id) {
  $.post(ubian.routes["basket_remove_item"], { id: id }, function(res) {
    // remove error messages
    if ($("#basket-error-" + id).length) {
      $("#basket-error-" + id)
        .parents(".row")
        .first()
        .remove();
    }
    // update prices and count
    value = $("[data-basket-item=" + id + "]")
      .find("[data-id=" + id + "]")
      .data("value");
    var parent = $("[data-basket-item=" + id + "]").parents("tbody");
    $("[data-basket-item=" + id + "]").remove();
    ubian.basketTotalPrice -= value;
    var priceFrac = ubian.utils.price(ubian.basketTotalPrice, "frac");
    var priceInt = ubian.utils.price(ubian.basketTotalPrice, "int");
    var priceAll = ubian.utils.price(ubian.basketTotalPrice);
    var itemCount = parseInt($(".js-basket-item-count").text()) - 1;
    $(".js-basket-item-count").text(itemCount);
    $(".js-basket-item-count").attr("data-itemcount", itemCount);
    $(".js-basket-price-int").text(priceInt);
    $(".js-basket-price-frac").text(priceFrac);
    $(".js-basket-price-all").text(priceAll);
    var lastItem = $(parent).find("tr:last");
    if (lastItem.hasClass("r2")){
      lastItem.removeClass("r2").addClass("r3");
    }
    if ($(parent).find("[data-basket-item]").length === 0) {
      $(parent).remove();
    }
    if (!res.containsInvalidItems){
      ubian.payments.unblockFromInvalidItems(res);
    }
    // force reload if there are no remaining items in basket
    if ($("[data-basket-item]").length === 0) {
      window.location = ubian.routes["card_dashboard"];
    }
  });
};
/**
 * shows additional info message in basket
 */
ubian.basket.showInfo = function() {
  if (typeof ubian.basket.info === "undefined") {
    return;
  }
  if (
    sessionStorage.getItem(ubian.basket.INFO_SHOWN_SESSION_KEY) ===
    ubian.basket.info.checksum
  ) {
    return;
  }
  ubian.utils.alert(
    ubian.basket.info.text,
    null,
    null,
    function() {
      sessionStorage.setItem(
        ubian.basket.INFO_SHOWN_SESSION_KEY,
        ubian.basket.info.checksum
      );
    },
    true
  );
};

/**
 * clear shown_info flag from session storages
 */
ubian.basket.clearInfoShown = function() {
  sessionStorage.removeItem(ubian.basket.INFO_SHOWN_SESSION_KEY);
};

function ShowBasketErrors() {
  var basketErrors = $("#basket-errors").children();
  if(basketErrors.length > 0) {
    basketErrors.each(function() {
      //console.log($(this).data("errorCode"));
      ubian.utils.alert(ubian.translate($(this).data("errorCode")), null, null, null);
    })

  }

}

$(function() {
  $(".js-remove-basket-item").click(function() {
    var id = $(this).data("id");
    ubian.basket.removeItem(id);
  });

  ubian.basket.showInfo();

  ShowBasketErrors();

});
